import INVENTORY_API_BASE_URL from "../../config/api";
import Table from "react-bootstrap/Table";
import "../SuperDistributor/superdistributor.css";
import Axios from "axios";
import { useState, useEffect } from "react";
import alertify from "alertifyjs";
import { CSVLink } from "react-csv";

const ManageSuperDist = () => {
  const [listO, setlistO] = useState([]);
  const [editingIndex, setEditingIndex] = useState(-1);
  const [editedValues, setEditedValues] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    Axios.get(
      `${INVENTORY_API_BASE_URL}/getCreatesuperdistributor`
    ).then((response) => {
      setlistO(response.data);
      setFilteredUsers(response.data);
    });
  }, []);

  const handleDelete = async (id) => {
    const shouldDelete = alertify("Are you sure you want to delete this user?");
    if (shouldDelete) {
      try {
        await Axios.delete(
          `${INVENTORY_API_BASE_URL}/superdistributor/${id}`
        );
      } catch (error) {
        console.error(error);
      }
      window.location.reload();
    }
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditedValues(listO[index]);
  };

  const handleInputChange = (e) => {
    setEditedValues({ ...editedValues, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      await Axios.put(
        `${INVENTORY_API_BASE_URL}/superdistributorEdit/${editedValues._id}`,
        editedValues
      );

      setEditingIndex(-1);
      setEditedValues({});
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  const csvHeaders = [
    { label: "Distributor Name", key: "dname" },
    { label: "Contact Person", key: "pname" },
    { label: "Mobile No", key: "mobno" },
    { label: "Alternate Mobile No", key: "amobno" },
    { label: "Whatsapp No", key: "whatsappno" },
    { label: "Billing Address", key: "billingaddress" },
    { label: "Shipping Address", key: "shippingaddress" },
    { label: "Discount (%)", key: "discount" },
    { label: "Aadhar Number", key: "aadhar" },
    { label: "GST Number", key: "gst" },
  ];

  return (
    <main className="distributordata-container">
      <div className="superdist-manage-content">
        <header className="superdist-page-heading">
          <div className="superdist-heading-copy">
            <p className="superdist-eyebrow">Partner network</p>
            <h1>Manage super distributors</h1>
            <p>Search, review, and update your distributor directory.</p>
          </div>
          <div className="superdist-total-card" aria-label="Total distributors">
            <span>Total distributors</span>
            <strong>{listO.length.toLocaleString()}</strong>
          </div>
        </header>

        <section className="superdist-toolbar" aria-label="Distributor tools">
          <label className="superdist-search">
            <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
              <circle cx="10.8" cy="10.8" r="6.5" />
              <path d="m16 16 4.2 4.2" />
            </svg>
            <input
              type="search"
              aria-label="Search by distributor name"
              value={searchQuery}
              placeholder="Search by distributor name"
              onChange={(e) => {
                setSearchQuery(e.target.value);
                const query = e.target.value.toLowerCase();
                const filtered = listO.filter((usr) =>
                  usr.dname.toLowerCase().includes(query)
                );
                setFilteredUsers(filtered);
              }}
            />
          </label>
          <span className="superdist-result-count">
            {filteredUsers.length.toLocaleString()}{" "}
            {filteredUsers.length === 1 ? "record" : "records"} shown
          </span>
          <CSVLink
            data={filteredUsers}
            headers={csvHeaders}
            filename="super_distributors.csv"
            className="superdist-export-button"
          >
            <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
              <path d="M12 3v11m0 0 4-4m-4 4-4-4" />
              <path d="M5 15v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4" />
            </svg>
            Download CSV
          </CSVLink>
        </section>

        <section className="superdist-directory-card" aria-label="Super distributor directory">
          <div className="superdist-directory-heading">
            <div>
              <h2>Distributor directory</h2>
              <p>Contact, billing, and compliance details for each partner.</p>
            </div>
            <span className="superdist-directory-count">
              {filteredUsers.length.toLocaleString()}{" "}
              {filteredUsers.length === 1 ? "result" : "results"}
            </span>
          </div>

          <div className="superdist-table-scroll" role="region" aria-label="Distributor records table" tabIndex="0">
            <Table bordered responsive size="sm" className="superdist-table">
              <thead>
                <tr>
                  {[
                    "No.",
                    "Distributor name",
                    "Contact person",
                    "Mobile",
                    "Alternate mobile",
                    "WhatsApp",
                    "Billing address",
                    "Shipping address",
                    "Discount",
                    "Aadhaar",
                    "GST",
                    "Actions",
                  ].map((heading) => (
                    <th key={heading} scope="col">{heading}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredUsers.length === 0 ? (
                  <tr>
                    <td className="superdist-empty-cell" colSpan={12}>
                      No distributors match your search.
                    </td>
                  </tr>
                ) : (
                  filteredUsers.map((usr, index) => {
                    const isEditing = editingIndex === index;

                    return (
                      <tr key={usr._id || index}>
                        <td className="superdist-row-number">{index + 1}</td>
                        <td className="superdist-name-cell">
                          {isEditing ? (
                            <input
                              className="superdist-edit-input"
                              aria-label="Distributor name"
                              name="dname"
                              value={editedValues.dname || ""}
                              onChange={handleInputChange}
                            />
                          ) : (
                            usr.dname
                          )}
                        </td>
                        <td>
                          {isEditing ? (
                            <input
                              className="superdist-edit-input"
                              aria-label="Contact person"
                              name="pname"
                              value={editedValues.pname || ""}
                              onChange={handleInputChange}
                            />
                          ) : (
                            usr.pname
                          )}
                        </td>
                        <td>
                          {isEditing ? (
                            <input
                              className="superdist-edit-input"
                              aria-label="Mobile number"
                              name="mobno"
                              value={editedValues.mobno || ""}
                              onChange={handleInputChange}
                            />
                          ) : (
                            usr.mobno
                          )}
                        </td>
                        <td>
                          {isEditing ? (
                            <input
                              className="superdist-edit-input"
                              aria-label="Alternate mobile number"
                              name="amobno"
                              value={editedValues.amobno || ""}
                              onChange={handleInputChange}
                            />
                          ) : (
                            usr.amobno
                          )}
                        </td>
                        <td>
                          {isEditing ? (
                            <input
                              className="superdist-edit-input"
                              aria-label="WhatsApp number"
                              name="whatsappno"
                              value={editedValues.whatsappno || ""}
                              onChange={handleInputChange}
                            />
                          ) : (
                            usr.whatsappno
                          )}
                        </td>
                        <td className="superdist-address-cell">
                          {isEditing ? (
                            <input
                              className="superdist-edit-input"
                              aria-label="Billing address"
                              name="billingaddress"
                              value={editedValues.billingaddress || ""}
                              onChange={handleInputChange}
                            />
                          ) : (
                            usr.billingaddress
                          )}
                        </td>
                        <td className="superdist-address-cell">
                          {isEditing ? (
                            <input
                              className="superdist-edit-input"
                              aria-label="Shipping address"
                              name="shippingaddress"
                              value={editedValues.shippingaddress || ""}
                              onChange={handleInputChange}
                            />
                          ) : (
                            usr.shippingaddress
                          )}
                        </td>
                        <td>
                          {isEditing ? (
                            <input
                              className="superdist-edit-input"
                              aria-label="Discount percentage"
                              name="discount"
                              value={editedValues.discount || ""}
                              onChange={handleInputChange}
                            />
                          ) : (
                            usr.discount
                          )}
                        </td>
                        <td>
                          {isEditing ? (
                            <input
                              className="superdist-edit-input"
                              aria-label="Aadhaar number"
                              name="aadhar"
                              value={editedValues.aadhar || ""}
                              onChange={handleInputChange}
                            />
                          ) : (
                            usr.aadhar
                          )}
                        </td>
                        <td>
                          {isEditing ? (
                            <input
                              className="superdist-edit-input"
                              aria-label="GST number"
                              name="gst"
                              value={editedValues.gst || ""}
                              onChange={handleInputChange}
                            />
                          ) : (
                            usr.gst
                          )}
                        </td>
                        <td className="superdist-actions-cell">
                          <div className="superdist-row-actions">
                            {isEditing ? (
                              <button
                                type="button"
                                className="superdist-button superdist-button--save"
                                onClick={handleSave}
                              >
                                Save
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="superdist-button superdist-button--edit"
                                onClick={() => handleEdit(index)}
                              >
                                Edit
                              </button>
                            )}
                            <button
                              type="button"
                              className="superdist-button superdist-button--delete"
                              onClick={() => handleDelete(usr._id)}
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ManageSuperDist;
